import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SeoContentLinksComponent } from './seo-content-links.component';
import { RouterModule } from '@angular/router';
import { SearchByIndustryPipe } from '@apply4u/shared/pipes/search-by-industry.pipe';

@NgModule({
  declarations: [
    SeoContentLinksComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    SearchByIndustryPipe,
  ],
  exports: [
    SeoContentLinksComponent
  ]
})
export class SeoContentLinksModule { }
